import { useCallback, useEffect, useState } from "react";

/**
 * Hook para cargar más mensajes al hacer scroll
 * 
 * @param {function} loadMoreFunction - Función para cargar más mensajes
 * @param {function} getScrollContainer - Función para obtener el contenedor del scroll
 * @returns {void}
 */
const useScrolltoLoad = (loadMoreFunction, getScrollContainer) => {
  const [isAtTop, setIsAtTop] = useState(false); // Estado del scroll
  const [lastLoadTimestamp, setLastLoadTimestamp] = useState(0); // Última vez que se cargaron mensajes
  const cooldown = 1000; // Cooldown para cargar mensajes

  /**
   * Maneja el evento de scroll
   * 
   * @returns {void}
   */
  const onScroll = useCallback(() => {
    const container = getScrollContainer();
    if (container) {
      const isTop = container.scrollTop === 0;
      setIsAtTop(isTop);
    }
  }, [getScrollContainer]);

  // Observar el scroll
  useEffect(() => {
    const container = getScrollContainer();
    if (container) {
      container.addEventListener("scroll", onScroll, { passive: true });
      return () => container.removeEventListener("scroll", onScroll);
    }
  }, [onScroll, getScrollContainer]);

  // Cargar más mensajes al llegar al tope
  useEffect(() => {
    if (isAtTop) {
      const now = Date.now();
      if (now - lastLoadTimestamp >= cooldown) {
        // El cooldown sirve para evitar que se hagan múltiples peticiones
        loadMoreFunction();
        setLastLoadTimestamp(now);
      }
    }
  }, [isAtTop, loadMoreFunction, lastLoadTimestamp]);
};

export default useScrolltoLoad;
